import {
  DocumentTranscriptParagraphV1,
  ScriptixDescendant
} from '@utils/types/editors/transcripts/transcript.ts';

export const getCurrentParagraphSeeking = (
  paragraphs: ScriptixDescendant[] | DocumentTranscriptParagraphV1[],
  currentTime: number
): ScriptixDescendant | DocumentTranscriptParagraphV1 | undefined => {
  const seekingValueInSec = currentTime ? currentTime * 1000 : 0;
  return paragraphs.find(
    paragraph =>
      paragraph.start &&
      paragraph.stop &&
      seekingValueInSec >= paragraph.start &&
      seekingValueInSec <= paragraph.stop
  );
};
